import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Компонент, який буде скролити сторінку наверх при зміні URL
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Коли маршрут змінюється, скролимо сторінку наверх
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Компонент не рендерить жодного UI
} 